import  { useEffect, useState } from 'react'
import { colors } from '../../Theme/tokens';
import { Box, Typography, TextField } from "@mui/material";
import { ApiService } from '../../API/AxiosInstance';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import ToastAlert from '../../utils/Toaster';
import { StyledErrorText } from '../../pages/Products/ProductDetails';
import { getYearDiff, numberRegex, lettersOnlyRegex, getErrorMessage } from '../../utils/validation';
import { ReactComponent as InfoIcon } from '../../img/settings/infoIcon.svg';

export default function EditProfile({isSaveClicked, setIsSaveClicked, setIsEdit}) {  
    const [userDatas, setUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobileNo: '',
        dateOfBirth: '',
      });
      const [errorUserData, setErrorUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobileNo: '',
        dateOfBirth: '',
      });
    const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
  const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
  // const numericRegex = /^\d*$/;

  useEffect(() => {
    if(userId) {
      getUserInfo()
    }
    return () => {
      setIsEdit(false)
    }
  },[userId])

  const getUserInfo = async() => {
    try {
      const response =  await ApiService().get(`users/${userId}`)
     if(response?.data?.user) {
       setUserData(response.data.user)
     }

   } catch(error) {
   }
  }

  const finalValidation = () => {
    let errors = {};

    if (!userDatas.firstName) {
      errors.firstName = "First Name is required.";
    }
    if (!userDatas.lastName) {
      errors.lastName = "Last Name is required.";
    }
    if (!userDatas.email) {
      errors.email = "Email is required.";
    }
    if (!userDatas.mobileNo) {
      errors.mobileNo = "Mobile Number is required.";
    } else if(userDatas.mobileNo && userDatas?.mobileNo?.length <5) {
      errors.mobileNo = "Mobile number need to have at least 5 characters";
    }
    if (!userDatas.dateOfBirth) {
      errors.dateOfBirth = "Date of Birth is required.";
    } else if(userDatas.dateOfBirth) {
        const yearsDifference = getYearDiff(moment(), moment(userDatas?.dateOfBirth));
        if (yearsDifference < 21) {
          errors.dateOfBirth = 'You must be at least 21 years old';
        }
    }
    setErrorUserData(errors);
    if(Object.keys(errors).length >0) {
      setIsSaveClicked(false)
    }
    return Object.keys(errors).length === 0;
  }

  const validate = (fieldName, fieldValue) => {
    let errors = {};
console.log("fieldName, fieldValue ",fieldName, fieldValue)
    if (fieldName == "firstName" && !fieldValue) {
      errors.firstName = "First Name is required.";
    }
    if (fieldName == "lastName" && !fieldValue) {
      console.log("witin")
      errors.lastName = "Last Name is required.";
    }
    if (!userDatas.email ) {
      errors.email = "Email is required.";
    }
    if (fieldName == "mobileNo" && !fieldValue) {
      errors.mobileNo = "Mobile Number is required.";
    } else if(fieldName == "mobileNo" && fieldValue && fieldValue?.length <5) {
      console.log("witin mob")
      errors.mobileNo = "Mobile number need to have at least 5 characters";
    }
    if (fieldName == "dateOfBirth" && !fieldValue) {
      errors.dateOfBirth = "Date of Birth is required.";
    } else if(fieldName == "dateOfBirth" && fieldValue) {
        const yearsDifference = getYearDiff(moment(), moment(fieldValue));
        if (yearsDifference < 21) {
          errors.dateOfBirth = 'You must be at least 21 years old';
        }
    }
    setTimeout(() => {
      setErrorUserData(prev => ({...prev, ...errors}));
    },100)
    if(Object.keys(errors).length >0) {
      setIsSaveClicked(false)
    }
    return Object.keys(errors).length === 0;
  }

  console.log("errorr ",errorUserData)

  useEffect(() => {
      if(isSaveClicked) {
        handleSave()
      }
  },[isSaveClicked])

  const handleInputChange = (e, fieldName) => {
    const { name, value } = e.target ? e.target : { name: fieldName, value: e };
    if(name == "mobileNo") {
      if(value?.length <=15 &&  numberRegex?.test(value)) {
         setUserData(prev=>({...prev, [name]: value}))
         validate(name, value)
      }
    } else if(name == "firstName" || name == "lastName") {
      if(lettersOnlyRegex?.test(value)) {
         setUserData(prev=>({...prev, [name]: value}))
         validate(name, value)
      }
    } else {
      setUserData(prev=>({...prev, [name]: value}))
      validate(name, value)
    }
    setErrorUserData(prev=>({...prev, [name]:""}))
  }

  console.log("userData ",userDatas)

  const handleSave = async() => {
    const validation = finalValidation()
    console.log("validation ",validation)
    if(!validation) return 
    const formattedValues = {...userDatas, dateOfBirth: moment(userDatas?.dateOfBirth).format('YYYY-MM-DD') || ''}
 
    try {
        const response =  await ApiService().post(`users/${userId}/update`, formattedValues)
        if(response?.status == 200) {
          setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
         setTimeout(() => {
          setIsEdit(false)
          getUserInfo()
         },2000)
          setTimeout(()=>{
            setToastStatus({color:'',status:false, message:""})
          },3000)
        }
  
     } catch(error) {
        setToastStatus({color:'red',status:true,message: getErrorMessage(error),icon:'close'})
          setTimeout(()=>{
            setToastStatus({color:'',status:false, message:""})
        },3000)
     }
     setIsSaveClicked(false)
  }

  return (
    <>
    <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
    <Box mt={2} sx={{  borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: colors.background.paper, boxShadow:`0px 1px 5px 0px ${colors.border.card}`, flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
          <Typography variant='h3'sx={{color:  colors.text.primary, fontWeight:"600", letterSpacing:"0.5%"}} >Personal Information</Typography>
        </Box>

       <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            gap:2
          }}
        >
      <Box sx={{ display: 'flex', flexDirection: 'column', width:{xs:"100%", md:"45%"},}}>
        <Box sx={{display:"flex", flexDirection:"column", gap:"5px", my: 1.5 }}>
          <Typography variant="h5_2" sx={{ color: colors.text.secondary, lineHeight: '37px' }}>
            First Name
          </Typography>
          <TextField
               InputProps={{
                sx: {
                  borderRadius: '8px',
                  color: colors.text.primary,
                  fontWeight:"500"
                },
              }}
            variant="outlined"
            name='firstName'
            value={userDatas?.firstName}
            onChange={handleInputChange}
            error={errorUserData?.firstName}
          />
          {errorUserData?.firstName && <StyledErrorText >{errorUserData?.firstName}</StyledErrorText>}
        </Box>
        <Box sx={{display:"flex", flexDirection:"column", gap:"5px", my: 1.5 }}>
          <Typography variant="h5_2" sx={{ color: colors.text.secondary, lineHeight: '37px' }}>
            Date of Birth
          </Typography>
           <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        sx={{width:"100%", borderRadius:"15px",
                          ".MuiOutlinedInput-notchedOutline": {
                            borderRadius: "8px",
                            borderColor: errorUserData.dateOfBirth ? "red" : "inherit", 
                          },
                        }}
                        format='Do MMMM, YYYY'
                        value={moment(userDatas?.dateOfBirth) || null}
                        onChange={(date) => handleInputChange(date, 'dateOfBirth')
                          
                        }
                        renderInput={(params) => <TextField  {...params}
                        />
                      }
                      
                    />
                    </LocalizationProvider>
                    {errorUserData?.dateOfBirth && <StyledErrorText >{errorUserData?.dateOfBirth}</StyledErrorText>}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column',  width:{xs:"100%", md:"45%"} }}>
        <Box sx={{display:"flex", flexDirection:"column", gap:"5px", my: 1.5 }}>
          <Typography variant="h5_2" sx={{  color: colors.text.secondary, lineHeight: '37px' }}>
            Last Name
          </Typography>
          <TextField
               InputProps={{
                sx: {
                  borderRadius: '8px',
                    color: colors.text.primary,
                  fontWeight:"500"
                },
              }}
            variant="outlined"
            name='lastName'
            value={userDatas?.lastName}
            onChange={handleInputChange}
            error={errorUserData?.lastName}
          />
          {errorUserData?.lastName && <StyledErrorText >{errorUserData?.lastName}</StyledErrorText>}
        </Box>
        <Box sx={{display:"flex", flexDirection:"column", gap:"5px", my: 1.5 }}>
          <Typography variant="h5_2" sx={{  color: colors.text.secondary, lineHeight: '37px' }}>
            Phone
          </Typography>
          <TextField
            InputProps={{
               maxLength: 15,
                sx: {
                  borderRadius: '8px',
                    color: colors.text.primary,
                  fontWeight:"500"
                },
              }}
            variant="outlined"
            name='mobileNo'
            value={userDatas?.mobileNo}
            onChange={handleInputChange}
            error={errorUserData?.mobileNo}
          />
          {errorUserData?.mobileNo && <StyledErrorText >{errorUserData?.mobileNo}</StyledErrorText>}
        </Box>
      </Box>
    </Box>
          <Box sx={{display:"flex", flexDirection:"column", gap:"5px", my: 1.5 }}>
          <Typography variant="h5_2" sx={{  color: colors.text.secondary, lineHeight: '25px' }}>
            Email Address
          </Typography>
          <Typography  sx={{  color: colors.neutral.outlinedText, fontSize:"18px", fontWeight:"500" }}>
            {userDatas?.email}
          </Typography>
          <Box sx={{display:"flex", gap:1}}>
              <InfoIcon />
              <Typography  sx={{  color: colors.text.secondary, fontSize:"12px", fontWeight:"500" }}>
            For your security, your email address cannot be changed.
          </Typography>
          </Box>
        </Box>

    </Box>
  </>
  )
}